/** @format */

import React from "react";
import MadrasahReform from "../../assets/img/madrasahReform.svg";
import Erkam from "../../assets/img/erkam_warna1.png";

/**
 * Header Login Area
 */
export const HeaderLogo = () => (
  <>
    <div className="flex justify-between mb-10 md:mb-16  xl:mb-20">
      <img
        aria-hidden="true"
        className=" w-auto h-10 md:h-16 xl:h-18"
        src={MadrasahReform}
        alt="Office"
      />
      <img
        aria-hidden="true"
        className="w-auto h-10 md:h-16 xl:h-18"
        src={Erkam}
        alt="Office"
      />
    </div>
    <h1 className="mb-4 mt-4 text-xl lg:text-2xl font-extrabold  text-center  text-gray-700 dark:text-gray-200">
      Rencana Kerja Anggaran Madrasah Berbasis Elektronik
    </h1>
  </>
);

/**
 * Footer Login Area
 */

export const FooterLogin = () => (
  <>
    <div className="flex justify-between mb-8 md:mb-8 xl:mb-10">
      <a
        href="https://pendis.kemenag.go.id/"
        // eslint-disable-next-line react/jsx-no-target-blank
        target="_blank"
        rel="noreferrer"
        className=" font-light md:text-base text-gray-700 dark:text-gray-700">
        Direktorat Jenderal Pendidikan Islam
      </a>
      <a
        // eslint-disable-next-line react/jsx-no-target-blank
        target="_blank"
        rel="noreferrer"
        href="https://kemenag.go.id/"
        className=" font-light md:text-base text-gray-700 dark:text-gray-700">
        Kementerian Agama Republik Indonesia
      </a>
    </div>
    <div className="copyright text-center">
      © e-RKAM Versi 2.0 All Rights Reserved.
    </div>
  </>
);
